// Called by : src/components/question/Question.vue (answer-upload)

<template>
  <base-modal ref="base-modal" pageId="answer_upload" pageClass="answer" modalClass="modal-lg" modalDataBack="true" modalDataKey="true" :key="keyModal">
  
    {{ forceUpdate }}

    <template #header>

        <h2 id="answer_upload_title" class="modal-title " :class="getClassTitle()">
            <sound-player :url="question.audioQuestion" role="answerQuestion" tone="btn-outline-warning mr-3"></sound-player>
            <span v-html="questionQuestion"></span>
            <!-- {{ questionQuestion }} -->
        </h2> <!-- Upload images -->

        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

    </template>
      
    <template #body>

      <div id="drop_files" class="dropbox" v-cloak @drop.prevent="addFileDrop" @dragover.prevent>
          <h4 class="vertical_center text-center p-4" style="top:12%!important;">
            <span class="oi oi-file mb-3" style="font-size:4rem;"></span>
            <br>
            {{ $t('answer.uploadInvit') }}
          </h4>
      </div>

      <div id="drop_jauge" class="dropbox d-none">
          <h4 class="vertical_center text-center p-4" style="top:12%!important;">
            <span style="font-size:6rem;text-shadow: 2px 2px 8px #999;">&#9203;</span>
          </h4>
      </div>

      <div id="list_files" class="text-black">
        <table class="table table-hover table-sm mt-4">
          <tbody class="border-bottom">
            <tr v-for="file in files" :key="file.name">
              <th scope="row" class="text-left pl-3">{{ file.name }}</th>
              <td class="text-center">{{ getFileTypeExt(file.name) }}</td>
              <td class="text-right">{{ getFileSize(file.size) }}</td>
              <td class="text-center"><button class="ui_tip btn btn-danger btn-sm py-0 px-2" @click="removeFile(file)" v-bind:title="uploadRemove">X</button></td> 
            </tr>
            <tr class="table-active" v-if="totalSize > 0">
              <th class="text-left pl-3">{{ $t('answer.uploadTotalSize') }}</th>
              <td>&nbsp;</td>
              <td class="text-right font-weight-bold">{{ getFileSize(totalSize) }}</td>
              <td class="text-center"><button v-if="files.length > 1" class="ui_tip btn btn-danger btn-sm py-0 px-2" @click="removeAllFiles()" v-bind:title="uploadRemoveAll">X</button></td>
            </tr>
          </tbody>
        </table>        
        <!-- &times; &#x274C; -->
      </div>

      <p class="alert alert-warning text-black mb-0" v-if="errMsg">{{ errMsg }}</p>

    </template>

    <template #footer>

      <input type="file" name="get_file" id="get_file" :accept="constants.typeUploads.all" style="display:none;" @change="addFileSelect" multiple>

      <div id="btns_group" class="btn-group btn-group-lg w-100">
        <button class="btn btn-secondary" :disabled="uploadDone" @click="selectFile">
          <span class="oi oi-browser mr-2"></span>
          {{ $t('answer.uploadFiles') }}
        </button>

        <button type="submit" class="btn_modal_submit btn btn-success" :disabled="getDisabled()" @click.stop="runUpload">
          <span class="oi oi-data-transfer-upload mr-2"></span>
          {{ $t('answer.upload') }}
        </button>
      </div>

    </template>

  </base-modal>
</template>

<script>
// loosely inspired by https://www.raymondcamden.com/2019/08/08/drag-and-drop-file-upload-in-vuejs
import { constants } from '@/constants'
import BaseModal from '@/components/BaseModal'
import SoundPlayer from '@/components/misc/SoundPlayer'

export default {
  components: {
    BaseModal,
    SoundPlayer,
  },
  props: {
    visible: Boolean,
    question: Object,
    answerGrp: String,
    isfr: Boolean,
  },
  data() {
    return {
      questionQuestion: '',
      langFr: true,
      files:[], // Liste des fichiers choisis par l'utilisateur
      filesUpload:[], // Liste des fichiers à uploader
      filesExists:[], // Liste d'infos pour détecter les éventuels doublons
      //* Les 5 variables suivantes il faut les régler dans les constantes, section "uploads"
      filesNbr: 4, // Nombre maximum des fichiers autorisés
      filesSize: 10000000, // 10000000 = 10 Mo ; 5000000 = 5 Mo (1000 = 1 Ko)
      videosSize: 50000000, // 50000000 = 50 Mo ; 20000000 = 20 Mo
      namesLength: 35, // Longueur totale (nombre de caractèrs) du nom original des fichiers (extension incluse)
      // Visiblement Fmp a du mal avec les noms des fichiers supérierus à une 50e de caractères,
      // si on désire avoir quelque chose comme "XXX_YYMMDDhhiiss_le_nom_original_du_fichier.mov"
      // il faut limiter la longueur du nom original du fichier à 35 caractères maximum
      isNameDateHour: true, // Faut-il inclure la date et l'haure au nom des fichiers ? (YYMMDDhhiiss)
      totalSize: 0,
      isInitial: true,
      isSaving: false,
      errMsg: '',
      uploadDone: false,
      uploadRemove: '',
      uploadRemoveAll: '',
      uploadProps: '',
      keyModal: false,
    }
  },
  methods:{
    getClassTitle() {
      return { 'answer_upload_title': this.question.audioQuestion }
    },
    selectFile() {
      document.getElementById('get_file').click();
    },
    getFileType(type) {
      return type.split('/').shift();
    },
    getDisabled() {
      let bOff = !this.files.length;
      f_setModalBtnOff_v(bOff);
      return bOff;
    },
    getFileTypeExt(name) {
      // Affichage du type de fichier correspondant à son extension
      // d'après les listes d'extension supportées présentes dans 'src/constants.js'
      // et traduites dans 'src/locales/locales.js' et converties au singulier
      var sExt = f_getFileExt_s(name);
      var sTypDft = this.$t('answer.uploadTypesDft');
      var sTypList = this.$t('answer.uploadTypesList');
      var sKey = '';
      var sRes = sTypDft;
      var oTypes = this.constants.typeUploads;
      for (let key in oTypes) {
        if ((key != 'all') && (oTypes[key].includes(sExt))) { 
          sKey = (key + ':'); 
          break; 
        }
      }
      if (sKey) sRes = sTypList.split(sKey)[1].split("|")[0];
      return sRes;
    },
    getFileSize(size) {
      // On gère l'affichage de la taille des fichiers en Ko et Mo
      // uploadProps = {kb:'Ko',mb:'Mo',decimal:','}
      let aProps = this.$t('answer.uploadProps').split('|');
      let nKo = Math.floor(size/1024);
      let nMo = (nKo/1000).toFixed(2);
      let sSize = String(nKo) + ' ' + aProps[0];
      if (nKo > 1000) sSize = String(nMo) + ' ' + aProps[1];
      return sSize.replace('.', aProps[2]);
    },
    addFile(files) {
      // console.log('filesSize',this.filesSize);
      // console.log('videosSize',this.videosSize);
      this.errMsg = '';
      // Initialisation des messages d'erreur
      var sErrNbr = this.$t('answer.uploadErrorFiles').replace('###', this.filesNbr);
      var nFileLimit = (this.filesSize/1000000); // Limite en Mo
      var nVideoLimit = (this.videosSize/1000000); // Limite en Mo
      var sErrFleSze = this.$t('answer.uploadErrorFilesSize').replace('###', nFileLimit);
      var sErrMovSze = this.$t('answer.uploadErrorVideosSize').replace('###', nVideoLimit);
      var sErrExs = this.$t('answer.uploadErrorExists');
      var nNbrOld = this.files.length;
      var nNbrNew = files.length;
      if (files.length === 0) {
        console.error('addFile : no uploaded files')
      } else if (nNbrOld >= this.filesNbr) {
        this.errMsg = sErrNbr;
      } else {
        var aFiles = Array.from(files);
        var nNew = this.filesNbr - nNbrOld;
        if ((nNbrOld + nNbrNew) > this.filesNbr) aFiles = aFiles.slice(0,nNew);
        for (const file of aFiles) {
          // Variable 'sInfos' pour détecter les éventuels doublons
          var sType = file.type.split("/").shift();
          var sInfos = [file.name, file.size, file.lastModified].join('');
          // Différents tests avant d'intégrer le fichier dans la liste des uploads
          if ((sType == 'video') && (file.size > this.videosSize)) {
            // console.log('video-size',file.size);
            this.errMsg = sErrMovSze;
          } else if (file.size > this.filesSize) {
            // console.log('file-size',file.size);
            this.errMsg = sErrFleSze;
          } else if (this.filesExists.includes(sInfos)) {
            // console.log('infos',sInfos);
            this.errMsg = sErrExs;
          } else { 
            // Fredo 15/12/21 : on nettoie le nom du fichier original en on crée un nouvel objet 'File'
            var sClean = f_setCleanNames_s(file.name, this.namesLength);
            var sName = [this.user.zkp, sClean].join('_');
            if (this.isNameDateHour) sName = [this.user.zkp, f_setDateTimeFormat_s(), sClean].join('_');
            var oFile = new File([file], sName, {type: file.type});
            // On renseigne les datas
            this.totalSize += file.size;
            this.files.push(file);
            this.filesUpload.push(oFile);
            this.filesExists.push(sInfos);
            this.errMsg = '';
            // On affiche sur la console
            // console.log('file',file);
            // console.log('newFile',oFile);
          }
        }
      }
      // console.log('files',this.files);
      // console.log('filesUp',this.filesUpload);
    },
    addFileSelect(e) {
      this.addFile(e.target.files)
    },
    addFileDrop(e) {
      this.addFile(e.dataTransfer.files)
    },
    removeFile(file){
      var sInfos = [file.name,file.size,file.lastModified].join('');
      var sName = f_setCleanNames_s(file.name);
      this.totalSize -= file.size;
      this.errMsg = '';
      this.files = this.files.filter(f => {
        return f != file;
      });      
      this.filesUpload = this.filesUpload.filter(u => {
        if (!u.name.includes(sName)) return u;
      });      
      this.filesExists = this.filesExists.filter(i => {
        return i != sInfos;
      });
      // console.log('files',this.files);
      // console.log('filesUp',this.filesUpload);
    },
    removeAllFiles() {
      this.files = [];
      this.filesUpload = [];
      this.filesExists = [];
      this.totalSize = 0;
      this.errMsg = '';
    },
    runUpload(){
      // Méthode pour rendre tous les boutons inactifs et afficher un sablier d'attente
      var oDrop = document.getElementById('drop_files');
      var oJauge = document.getElementById('drop_jauge');
      var oList = document.getElementById('list_files');
      var oDels = document.querySelectorAll('div#list_files button.btn');
      var oBtns = document.querySelectorAll('div#btns_group > button.btn');
      oDrop.classList.add('d-none');
      oJauge.classList.remove('d-none');
      oList.classList.remove('text-black');
      oList.classList.add('text-muted','alert-secondary');
      oDels.forEach(function(oDel) {
        oDel.setAttribute('disabled','disabled');
      });
      oBtns.forEach(function(oBtn) {
        oBtn.setAttribute('disabled','disabled');
      });
      setTimeout(this.upload, 1000); // 1 seconde de temporisation
    },
    upload() {
      // Fredo 15/12/21 : On utilise le tableau 'filesUpload' pour passer les fichiers à uploader
      // Plus besoin du coup de passer le 'userzkp' déjà présent dans le nom des fichiers
      let formData = new FormData();
      this.filesUpload.forEach((file,x) => {
        formData.append('file'+(x+1), file);
      });

      // var sUpPath = '/' + constants.project.path + '/up/upload.php';
      var sUpPath = './up/upload.php';
      fetch(sUpPath, {
        method:'POST',
        body: formData,
        headers: {
          'enctype': 'multipart/form-data',
        },
      })
      .then(res => {
        this.uploadDone = true;
        setTimeout(this.sendToDb, 5000); // 1000 = 1 seconde de temporisation
      })
      .catch(e => {
        this.uploadDone = false;
        this.errMsg = JSON.stringify(e.message)
        console.error(JSON.stringify(e.message))
      });
    },
    sendToDb() {
      // let parameters = this.user.zkp + '|' + this.answerGrp + '|' + this.question.zkp + '|'
      // parameters += this.files.map(file => this.user.zkp + '_' + file.name).join('|')

      let sFmpParams = [this.user.zkp, this.answerGrp, this.question.zkp].join('|');
      let sFilesParams = this.filesUpload.map(file => file.name).join('|');
      let sScriptParams = sFmpParams + '###' + sFilesParams;
      this.model.runScript('UPL_js', '2022_VUEJS_Uploads_Set', sScriptParams);

      // On vide les principales variables et on ferme la modale
      this.files = [];
      this.filesUpload = [];
      this.filesExists = [];
      this.totalSize = 0;
      this.errMsg = '';
      $('#answer_upload').modal('hide');
      // On valide l'envoi pour passer à la question suivante
      this.$emit('save', 'AnswerUpload');
    },
    getKey(sId) {
      return sId + f_getRandomMinMax_n(100000000, 999999999);
    },
  },
  computed: {
    model() {
      return this.$store.state.model
    },
    user() {
      return this.$store.state.user
    },
    forceUpdate() {
      // this.langFr = Boolean(this.lesson.lang.toLowerCase() === "fr");
      this.questionQuestion = (this.isfr) ? f_setCleanSpacesFr_s(this.question.question) : this.question.question;
      if (!this.keyModal) this.keyModal = this.getKey('ModalUpld');
      this.uploadRemove = this.$t('answer.uploadRemove');
      this.uploadRemoveAll = this.$t('answer.uploadRemoveAll');
      this.files = [];
      this.filesUpload = [];
      this.filesExists = [];
      this.totalSize = 0;

      this.filesNbr = constants.uploads.filesNbr;
      this.filesSize = (this.params.uploadSizeFiles) ? (this.params.uploadSizeFiles * 1000000) : constants.uploads.filesSize;
      this.videosSize = (this.params.uploadSizeVideos) ? (this.params.uploadSizeVideos * 1000000) : constants.uploads.videosSize;
      this.namesLength = constants.uploads.namesLength;
      this.isNameDateHour = constants.uploads.isNameDateHour;
      
      this.errMsg = '';
      return '';
    },
    constants() {
      return constants
    },  
    params() {
      return this.$store.state.params
    },  
  },
  mounted: function() {
    this.keyModal = false;
    this.filesSize = (this.params.uploadSizeFiles) ? (this.params.uploadSizeFiles * 1000000) : constants.uploads.filesSize;
    this.videosSize = (this.params.uploadSizeVideos) ? (this.params.uploadSizeVideos * 1000000) : constants.uploads.videosSize;
  },
}
</script>

<style scoped>
h2.answer_upload_title {
  padding-left: 56px !important;
  text-indent: -56px !important;
}
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
.modal-container {
  width: 500px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/question/AnswerUpload.vue